module.exports = __webpack_public_path__ + "static/media/mentor_marketing.a703e177.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/mentor_marketing.jpg
// module id = 402
// module chunks = 0